import logo from '../../assets/logo.png';

const navItems = [
  { section: 'Main' },
  { id: 'dash', label: '▸ Overview' },
  { id: 'profile', label: '▸ My Profile' },
  { id: 'clients', label: '▸ Clients' },
  { id: 'projects', label: '▸ Projects' },
  { section: 'Services' },
  { id: 'webdev', label: '▸ Website Dev' },
  { id: 'ai', label: '▸ AI & ML' },
  { id: 'research', label: '▸ Research & Technical' },
  { section: 'Documents' },
  { id: 'contracts', label: '▸ Contracts & Docs' },
  { id: 'invoice', label: '▸ Invoices' },
  { id: 'messages', label: '▸ Messages' },
  { section: 'Account' },
  { id: 'settings', label: '▸ Settings' },
];

export default function Sidebar({ page, setPage, onLogout }) {
  return (
    <div className="dash-sidebar">
      <div className="dash-logo">
        <img src={logo} alt="LathiNyx DevLabs" />
        <div className="dash-logo-text">
          LathiNyx <span>DevLabs</span><sup style={{ fontSize: 8, color: '#ff7c90', verticalAlign: 'super', marginLeft: 1 }}>™</sup>
        </div>
        <div className="dash-logo-sub">Engineering Digital Growth</div>
      </div>

      {navItems.map((item, i) =>
        item.section ? (
          <div key={i} className="dash-nsec">{item.section}</div>
        ) : (
          <div
            key={item.id}
            className={`dash-nitem${page === item.id ? ' active' : ''}`}
            onClick={() => setPage(item.id)}
          >
            {item.label}
          </div>
        )
      )}

      <div className="dash-nitem logout" onClick={onLogout} style={{ marginTop: 'auto', marginBottom: 8 }}>
        🚪 Logout
      </div>
    </div>
  );
}
